import React from 'react';
import PropTypes from 'prop-types'
import Geosuggest from 'react-geosuggest'

const noop = () => {
}

export const PootsyTextInput = ({ placeholder, name = "", value, disabled, customClass = "", onChange = noop, type = "text", showRequired = false, min, max, label = "" , secondaryLabel, showError = '', onKeyPress = noop  }) => {
	let textInputClass = "input " + (showError !== '' ? " show-error" : "")
	let labelClass = "label " + (showError !== '' ? " show-error" : "")

	let errorLabel = (showError !== '' ? showError : null)

	return (
		<div className={"PootsyTextInput " + customClass}>
			<div className="labels">
				{label !== null && <div className={labelClass}>{label}</div>}
				{secondaryLabel !== null && <div className="label">{secondaryLabel}</div>}
			</div>
			<input
				className={textInputClass} required type={type}
				value={value} name={name} onChange={onChange} disabled={disabled}
				min={min} max={max} placeholder={placeholder} onKeyPress={onKeyPress}
			/>
			{errorLabel !== null && <div className="show-error">{errorLabel}</div>}
		</div>
	)
}

export const PootsyRadioInputs = ({ selectedValue, options, customItemClass, onChange = noop }) => {

	return (
		<div className="PootsyRadioInputs">
			{options.map((option, index) =>
				<div
					className={"item" + (customItemClass ? " " + customItemClass : "") + (selectedValue === option.value ? " checked" : "")}
					key={index}
					data-selectedvalue={option.value}
					onClick={onChange}>{option.label}</div>
			)}
		</div>
	)
}

export const PootsySelectInput = ({ name, options, defaultText, selected, customClass = "", showRequired = false, disabled, allowEmpty = false, onChange = noop }) => {
	let wrapperClass = "pootsy-input select " + customClass
	let inputFinalClass = "pootsy-select"
	showRequired && (wrapperClass += " show-required");
	selected !== "" && (inputFinalClass += " option-chosen");
	return (
		<div className={wrapperClass}>
			<select name={name} className={inputFinalClass} value={selected} disabled={disabled} onChange={onChange}>
				<option value="" disabled={!allowEmpty}></option>
				{options.map(entry => <option key={entry.value} value={entry.value}>{entry.label}</option>)}
			</select>
			<label className="select-text-label">{defaultText}</label>
		</div>
	)
}

export const PootsyCheckboxInput = ({ label, name, checked, onChange = noop }) => {
	return (
		<div className="PootsyCheckboxInput">
			<input type="checkbox" name={name} id={name} checked={checked} onChange={onChange}/>
			<label className="checkbox-text-label" htmlFor={name}>{label}</label>
		</div>
	)
}

export const GeosuggestInput = ({ geoSuggestProps }) => (
	<Geosuggest
		{...geoSuggestProps}
		className="GeosuggestInput"
		inputClassName="geosuggest-input"
		suggestsClassName="suggestions"
		suggestItemClassName="suggestion"
	/>
)
export const PootsyAddressBlockInputs = ({ values, handleChanges, showRequired = {} }, context) => {
	let { t } = context
	return (
		<div className="pootsy-address-block">
			<PootsyTextInput name="street" label={t("street")}
							 customClass="address-input street"
							 onChange={handleChanges}
							 showRequired={showRequired.street}
							 value={values.street}
			/>
			<PootsyTextInput name="streetNumber" type="number" label={t("number")}
							 customClass="address-input number"
							 onChange={handleChanges}
							 showRequired={showRequired.streetNumber}
							 value={values.streetNumber}
			/>
			<PootsyTextInput name="box" label={t("box")}
							 customClass="address-input box"
							 onChange={handleChanges}
							 value={values.box}
			/>
			<PootsyTextInput name="zip" type="number" label={t("zip_code")}
							 customClass="address-input zip"
							 onChange={handleChanges}
							 showRequired={showRequired.zip}
							 value={values.zip}
			/>
			<PootsyTextInput name="city" label={t("city")}
							 customClass="address-input city"
							 onChange={handleChanges}
							 showRequired={showRequired.city}
							 value={values.city}
			/>
		</div>
	)
}
PootsyAddressBlockInputs.contextTypes = { t: PropTypes.func }


export const PootsyTextArea = ({ label, placeholder, value, name, onChange = noop, onKeyPress = noop }) => (
	<div className="PootsyTextArea">
		{label && <div className="label">{label}</div>}
		<textarea required name={name} value={value} placeholder={placeholder} onChange={onChange} onKeyPress={onKeyPress}/>
	</div>
)



// WEBPACK FOOTER //
// ./src/components/InputsFunctions.js